import { createAction, props } from '@ngrx/store';
import { IEventLog } from '../../../../model/event-logs';
import { ILocationContext } from '../../../../model/location-context';

export const requestEventLogs = createAction(
    '[Event Logs] Request Event Logs',
    props<{ locationContext: ILocationContext }>()
);

export const loadEventLogs = createAction('[Event Logs] Load Event Logs', props<{ eventLogs: IEventLog[] }>());
